/*
 * View for the top level menu bar
 */

define([
  "marionette",
  "modules/header/menuBar/template/menuBarTemplate.html",
  "modules/header/menuBar/template/menuItemTemplate.html",
], function (Marionette, MenuBarTemplate, MenuItemTemplate) {
  var MenuBarView = {};

  MenuBarView.menuItemView = Marionette.ItemView.extend({
    template: MenuItemTemplate,
    tagName: "li",
    hideItem: function () {
      this.model.set("hidden", true);
      this.$el.hide();
    },
    modelEvents: {
      "change:hidden": "toggleShow",
    },
    onRender: function () {
      this.$el.i18n();
      //if the menu item is inactive, hide it
      if (this.model.get("hidden")) {
        this.hideItem();
      }
    },
    showItem: function () {
      this.model.set("hidden", false);
      this.$el.show();
    },
    toggleActive: function () {
      this.$el.toggleClass("active");
      if (this.$el.find("a").is(":focus")) {
        this.$el.find("a").trigger("blur");
      }
    },
    toggleShow: function () {
      if (this.model.get("hidden")) {
        this.hideItem();
      } else {
        this.showItem();
      }
    },
    triggers: {
      "click a": "click:menu",
    },
  });

  MenuBarView.menuBarView = Marionette.CompositeView.extend({
    template: MenuBarTemplate,
    itemViewContainer: "ul",
    itemView: MenuBarView.menuItemView,
  });

  return MenuBarView;
});
